import type { ExtractionImageType } from "./extraction";
import { EXTRACTION_IMAGE_TYPE_LABELS } from "./extraction";

export type DealImageSource = "manual" | "ai_extraction";
export type DealImageType = ExtractionImageType;

export function formatDealImageTypeLabel(
  imageType: DealImageType | string | null | undefined,
): string | null {
  if (!imageType) return null;
  if (imageType in EXTRACTION_IMAGE_TYPE_LABELS) {
    return EXTRACTION_IMAGE_TYPE_LABELS[imageType as ExtractionImageType];
  }
  return imageType
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export interface DealImage {
  id: number;
  deal_id: number;
  url: string;
  width: number | null;
  height: number | null;
  caption: string | null;
  image_type: DealImageType | null;
  is_hero: boolean;
  source: DealImageSource;
  extraction_image_id: number | null;
  created_at: string;
}

export interface DealImagesResponse {
  deal_id: number;
  hero: DealImage | null;
  images: DealImage[];
}

export interface DealHeroImageResponse {
  deal_id: number;
  hero: DealImage | null;
}
